import React from "react";

class RatesTable extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	renderRateValue = (rate) => {
		if (rate) {
			const { percent, fixed } = rate;
			const hasPercent = percent && percent > 0;
			const hasFixed = fixed && fixed > 0;
			const hasBoth = hasPercent && hasFixed;

			if (hasBoth) return `${percent}% + $${fixed.toFixed(2)}`;
			else {
				if (hasPercent) return `${percent}%`;
				if (hasFixed) return `$${fixed.toFixed(2)}`;
			}
		}
	};

	renderRates = (rates) => {
		const { MDRTypes, prefix } = this.props;
		return Object.keys(MDRTypes).map((type) => {
			const rate = rates[type];
			if (rate)
				return (
					<tr key={`${prefix}-${type}`}>
						<td className="uk-width-1-3">
							<img
								className="uk-img"
								src={`data:image/*;base64,${MDRTypes[type].image}`}
								width="35"
							/>
							<span className="uk-margin-small-left">
								{MDRTypes[type].label}
							</span>
						</td>
						<td className="uk-width-1-3 uk-text-center">
							{this.renderRateValue(rate.local)}
						</td>
						<td className="uk-width-1-3 uk-text-center">
							{this.renderRateValue(rate.overseas)}
						</td>
					</tr>
				);
		});
	};

	renderRateTable = (rates) => {
		return (
			<>
				<table className="uk-table uk-table-striped uk-table-middle uk-margin-top uk-margin-remove-bottom">
					<thead>
						<tr>
							<th className="uk-width-1-3">Payment Type</th>
							<th className="uk-width-1-3 uk-text-center">Local Card</th>
							<th className="uk-width-1-3 uk-text-center">Overseas Card</th>
						</tr>
					</thead>
				</table>
				<div className="reseller-rates-table uk-overflow-auto">
					<table className="uk-table uk-table-striped uk-table-middle uk-margin-remove-top">
						<tbody>{this.renderRates(rates)}</tbody>
					</table>
				</div>
			</>
		);
	};

	render() {
		const { currencyRates, isList, header } = this.props;
		return isList ? (
			<li>{this.renderRateTable(currencyRates)}</li>
		) : (
			<div>
				<h2 className="uk-modal-title">{header}</h2>
				{this.renderRateTable(currencyRates)}
			</div>
		);
	}
}

export default RatesTable;
